import { createReducer } from 'redux-create-reducer';

import { GET_WATCH_LISTS } from '../types';

const initialState = [];

const watchListsReducer = createReducer(initialState, {
  [GET_WATCH_LISTS.FULFILLED]: (state, { payload }) => payload.data,
});

export default watchListsReducer;


// WEBPACK FOOTER //
// ./src/reducers/watchListsReducer.js